import { render, staticRenderFns } from "./ModalDifferencesPatientFonasa.vue?vue&type=template&id=15397331"
import script from "./ModalDifferencesPatientFonasa.vue?vue&type=script&lang=ts"
export * from "./ModalDifferencesPatientFonasa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports